var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-info"},[_c('ei-header',{attrs:{"header2-show":true,"header2-lit":true}}),_c('div',{staticClass:"top-margin"}),_c('el-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }